/**
 * 用户相关
 */
import request from '@/utils/request.js'

export default {
  // 登录
  Login (data) {
    return request({
      url: '/api/User/Login',
      method: 'POST',
      tips: true,
      loading: '登录中...',
      data: data
    })
  },

  // 修改密码
  ModifyPwd (data) {
    return request({
      url: '/api/Account/ModifyPwd',
      method: 'POST',
      tips: true,
      loading: true,
      data: data
    })
  },

  // 修改头像
  ModifyAvatar (data) {
    return request({
      url: '/api/Account/ModifyAvatar',
      method: 'POST',
      tips: true,
      loading: true,
      data: data
    })
  },

  // 修改用户信息
  UserInfoAvatar (data) {
    return request({
      url: '/api/Account/UserInfoAvatar',
      method: 'POST',
      tips: true,
      loading: true,
      data: data
    })
  }

}
